import { t } from "@lingui/macro";
import { Breadcrumb as BreadcrumbAntd } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, matchPath, useLocation } from "react-router-dom";
import { selectBreadcrumbs } from "store/app/app.slice";
import { BreadcrumbType, RouteEl } from "types";
import { translate } from "utils";
import routes from "../routes/routes";

const Breadcrumb: React.FC = () => {
	const { pathname } = useLocation();
	const [breadcrumbItems, setBreadcrumbItems] = useState<BreadcrumbType[]>([]);
	const breadcrumbs = useSelector(selectBreadcrumbs);

	useEffect(() => {
		if (breadcrumbs.length > 0) {
			setBreadcrumbItems(breadcrumbs);
			return;
		}

		const listBreadcrumbItem: BreadcrumbType[] = [];
		const dashboard = routes.find(el => el.path === "/dashboard");
		if (dashboard) addItem(dashboard);

		if (pathname === "/dashboard") {
			setBreadcrumbItems(listBreadcrumbItem);
			return;
		}

		const pathnameArr = pathname.split("/");
		pathnameArr.splice(0, 1);

		if (pathnameArr.length === 1) {
			findRouteMatch(pathname);
		}
		// custom handle for merchant detail (will be refactored in the future)
		else if (pathnameArr.length === 4 && pathnameArr.includes("merchant")) {
			findRouteMatch("/" + pathnameArr[0]);
			addItem({
				label: t`Merchant Detail`,
				path: `${pathnameArr[0]}/${pathnameArr[1]}?tab=${pathnameArr[2]}`,
				key: "merchantDetail",
			});
			findRouteMatch(pathname);
		} else if (pathnameArr.length >= 2) {
			findRouteMatch("/" + pathnameArr[0]);
			findRouteMatch(pathname);
		}

		function findRouteMatch(pathname: string) {
			let routeMatch = routes.find(route =>
				matchPath({ path: route.path }, pathname) ? true : false,
			);
			routes.forEach(route => {
				if (matchPath({ path: route.path }, pathname)) {
					routeMatch = route;
				}
				if (route.children) {
					route.children.forEach(child => {
						if (matchPath({ path: child.path }, pathname)) {
							routeMatch = child;
						}
					});
				}
			});
			if (routeMatch) {
				addItem(routeMatch);
			}
		}

		function addItem(route: RouteEl) {
			listBreadcrumbItem.push({
				label: translate(route.label),
				path: route.path,
				icon: route.icon,
			});
		}
		setBreadcrumbItems(listBreadcrumbItem);
	}, [pathname, breadcrumbs]);

	return (
		<BreadcrumbAntd>
			{breadcrumbItems.map((el, index: number) => (
				<BreadcrumbAntd.Item key={el.label}>
					{!(index === breadcrumbItems.length - 1) ? (
						el.path && (
							<Link key={el.path} to={el.path}>
								<span className="relative pr-1" style={{ bottom: "3px" }}>
									{el.icon}
								</span>
								<span>{el.label}</span>
							</Link>
						)
					) : (
						<>
							<span className="relative pr-1" style={{ bottom: "3px" }}>
								{el.icon}
							</span>
							<span>{el.label}</span>
						</>
					)}
				</BreadcrumbAntd.Item>
			))}
		</BreadcrumbAntd>
	);
};

export default Breadcrumb;
